import FontFaceObserver from "fontfaceobserver";

// TODO: реальные шрифты
var Roboto = new FontFaceObserver("Roboto");

Promise.all([Roboto.load()]).then(function () {
    document.documentElement.classList.add("fonts-loaded");
});
